import { computed } from 'vue';

export function useCvButtonNavigation() {
  const cvButtonTo = computed(() => {
    return {
      path: '/register',
      query: {
        redirect: `/chat/diagnosis`,
      },
    };
  });

  return {
    cvButtonTo,
  };
}
